export enum ModalStatusApproveBatchEnum {
	INACTIVE = 'inactive',
	REVIEWING = 'reviewing',
	DISCARD_CONFIRMATION = 'discardConfirmation',
	LOADING = 'loading',
	SUCCESS = 'success',
	FAILED = 'failed'
}
